import {
  GET_BUDGET_MANAGEMENT_REPORT_FETCH,
  GET_BUDGET_MANAGEMENT_REPORT_SUCCESS,
  GET_BUDGET_MANAGEMENT_REPORT_REJECTED,
  GET_BUDGET_MANAGEMENT_REPORT_CLEAR,
} from "./../../Constants";

import { httpClient } from "./../../utils/HttpClient";

export const getReportBudgetManagement = ({
  PR_YEAR,
  PR_BRANDID,
  PR_DEPARTID,
  PR_COUNTRYID,
  PR_COMPANYID,
}) => {
  return async (dispatch) => {
    dispatch({
      type: GET_BUDGET_MANAGEMENT_REPORT_FETCH,
    });
    try {
      const result = await httpClient.get(
        `/purchase-request/report/budget-management/${PR_YEAR}/${PR_COMPANYID}/${PR_COUNTRYID}/${PR_BRANDID}/${PR_DEPARTID}`
      );
      dispatch({
        type: GET_BUDGET_MANAGEMENT_REPORT_SUCCESS,
        payload: result.data,
      });
    } catch (err) {
      dispatch({ type: GET_BUDGET_MANAGEMENT_REPORT_REJECTED });
    }
  };
};

export const clearReportBudgetManagement = () => {
  return (dispatch) => {
    dispatch({ type: GET_BUDGET_MANAGEMENT_REPORT_CLEAR });
  };
};
